
var intervals = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
var start_time = 8;
var end_time = 3
import moment from 'moment';
export function generateTimeSeries(){
    let time = [];
    /* generate am time */
    for (let i = start_time; i < 12; i++) {
        for (let j = 0; j < 60; j++) {
            if(j <= 9){
                time.push(`${i}:0${j} am`);
            } else {
                time.push(`${i}:${j} am`);
            }
        }
    }
    /* generate noon time */
    for (let k = 11; k < 12; k++) {
        for (let j = 0; j < 60; j++) {
            if(j <= 9){
                time.push(`${k+1}:0${j} pm`);
            } else {
                time.push(`${k+1}:${j} pm`);
            }
        }
    }
    /* genrate pm time */
    for (let j = 1; j < end_time; j++) {
        for (let jj = 0; jj < 60; jj++) {
            if(jj <= 9){
                time.push(`0${j}:0${jj} pm`);
            } else {
                time.push(`0${j}:${jj} pm`);
            }
        }
    }
    time.push(`0${end_time}:00 pm`);
    return time;
}

export function checkMinInterval(min): boolean{
    if(intervals.indexOf(min) >=0){
      return true;
    }
}

export function removeDublicateEntries(arr: Array<string>){
    return arr.filter((item, pos, self) => {
        return self.indexOf(item) == pos;
    });
}

export function makeToFixed(data: Array<number>): Array<number>{
    return data.map((el)=>{
      return Number(el.toFixed(2));
    });
}

export function filterArrayGtZero(arr: Array<number>){
    return arr.filter((element)=>{
      return element > 0
    });
}

export function convertDateFormat(date:any[], format){
    return date.map((element)=>{
      let d = new Date(element).toUTCString();
      return moment(d).utc().format(format);
    });
}

export function volatilityChart(time, price, volume, type?: string) {
    let legendData = ['Price', 'Volume'];
    let xAxisType = 'category';
    let option = {
      colors: ['#5793f3', '#d14a61', '#675bba'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        show: false,
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      legend: {
        type: 'scroll',
        data: legendData,
        left: 10,
        x: 'left',
        textStyle: {
          color: type == 'crypto' ? '#fff': null
        }
      },
      xAxis: [
        {
          type: xAxisType,
          data: time,
          // axisPointer: {
          //   type: 'shadow'
          // },
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Price',
          position: 'left',
          min: Math.min.apply(null, price),
          max: Math.max.apply(null, price),
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: true,
          },

        },
        {
          type: 'value',
          name: 'Volume',
          position: 'right',
          min: Math.min.apply(null, volume),
          max: Math.max.apply(null, volume),
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: true,
          },
        }
      ],
      series: [
        {
          name: 'Price',
          type: 'line',
          data: price,
        },
        {
          name: 'Volume',
          type: 'bar',
          data: volume,
          yAxisIndex: 1,
        }
      ]
    };

    return option;
}

export function isValidNumber(num) {
  return num != null && num != undefined && isFinite(num) && !isNaN(num);
}


export function getPercentageChange(price: number, previousClosePrice: number): number {
  if(price > 0 && previousClosePrice > 0){
    let change = Number((((price / previousClosePrice) - 1) * 100).toFixed(2))
    return isValidNumber(change) ? change : 0;
  }
  return 0;
}